import { Box, Typography } from '@mui/material';
import { Receipt as ReceiptIcon } from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import { useDocumentTitle } from '../../hooks/core';
import { TransactionHistory, type TransactionTab } from '../../components/profile';

// Valid tab values for URL routing
const VALID_TABS: TransactionTab[] = ['purchases', 'usage'];

export function TransactionHistoryPage() {
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();

  // Validate and normalize tab from URL
  const activeTab: TransactionTab = tab && VALID_TABS.includes(tab as TransactionTab)
    ? (tab as TransactionTab)
    : 'purchases';

  // Update document title based on active tab
  const tabTitle = activeTab === 'usage' ? 'Credit Usage' : 'Credit Purchases';
  useDocumentTitle(`${tabTitle} - Transaction History`);

  const handleTabChange = (newTab: TransactionTab) => {
    // Navigate to the new tab URL
    navigate(`/profile/transactions/${newTab}`, { replace: true });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <ReceiptIcon color="primary" sx={{ fontSize: 32 }} />
        <Typography variant="h4">Transaction History</Typography>
      </Box>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        View your credit purchases and how you've used your credits.
      </Typography>

      <TransactionHistory activeTab={activeTab} onTabChange={handleTabChange} />
    </Box>
  );
}
